module.exports = __webpack_public_path__ + "static/media/pizza-image-2.9e471edc.png";